  document.addEventListener('DOMContentLoaded', function() {
    var weglotSwitcher = document.querySelector('.weglot_switcher');
    if (weglotSwitcher && weglotSwitcher.getAttribute('aria-label') === 'Language selected: Deutsch') {

      function updateProductImage(image) {
        var metafieldLink = image.getAttribute('data-metafield-link');
        if (metafieldLink) {
          image.setAttribute('srcset', metafieldLink);
        }
      }

      function updateProductImages() {
        document.querySelectorAll('.product--image').forEach(function(image) {
          updateProductImage(image);
        });
      }

      var observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            updateProductImage(entry.target);
            observer.unobserve(entry.target); // Stop observing once updated
          }
        });
      }, {
        rootMargin: '0px',
        threshold: 0.1
      });

      document.querySelectorAll('.product--image').forEach(function(image) {
        observer.observe(image);
      });

      /*var swiperButtonNext = document.querySelector('.swiper-button-next');
      if (swiperButtonNext) {
        swiperButtonNext.addEventListener('click', updateProductImages);
      }*/

      updateProductImages(); // Initial call to update images
    }
  });